export enum BlackListTypes {
  'LOAD_REQUEST' = '@blackList/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@blackList/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@blackList/LOAD_FAILURE',

  'FILTER_BLACKLIST' = '@blackList/FILTER_BLACKLIST',
  'CLEAN_BLACKLIST' = '@blackList/CLEAN_BLACKLIST',
}

export interface IMotorista {
  obs: string;
  cpf: string;
  nome: string;
  codMotorista: number;
}

export interface IVeiculo {
  obs: string;
  codVeiculo: number;
  placa: string;
}

export interface IBlackList {
  motorista?: IMotorista;
  veiculo?: IVeiculo;
  total: number;
}

export interface IFilter {
  cpf?: string;
  placa?: string;
}

export interface PaginationProps {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface BlackListState {
  readonly data: IBlackList[];
  readonly error: boolean;
  readonly loading: boolean;
  readonly filter?: IFilter;
  readonly pagination: PaginationProps;
}
